import PropTypes from 'prop-types';
import { Anchor, Tooltip } from '@mantine/core';
import { Tooltip as Tippy } from 'react-tippy';
import {
	LIMITED_EDITOR_TOOLTIP_SPAN_STYLE,
	LIMITED_EDITOR_TOOLTIP_ANCHOR_STYLE
} from 'src/new_arch/modules/projectMembers/components/LimitedEditorPaywallTooltip/LimitedEditorPaywallTooltip';

const INTERACTIVE_POPPER_OPTIONS = {
	modifiers: {
		flip: { enabled: false },
		preventOverflow: { enabled: false }
	}
};

const InteractiveTooltip = ( { children, tooltip, onCTAClick, position } ) => {
	const lines = tooltip.split( '\n' );
	const mainText = lines.slice( 0, -1 ).join( '\n' );
	const ctaText = lines[ lines.length - 1 ];

	return (
		<Tippy
			trigger="mouseenter"
			interactive
			position={position}
			distance={10}
			duration={200}
			arrow
			animation="fade"
			className="Tooltip"
			popperOptions={INTERACTIVE_POPPER_OPTIONS}
			html={(
				<span style={LIMITED_EDITOR_TOOLTIP_SPAN_STYLE}>
					{mainText}<br />
					<Anchor component="button" onClick={onCTAClick} style={LIMITED_EDITOR_TOOLTIP_ANCHOR_STYLE}>
						{ctaText}
					</Anchor>
				</span>
			)}
		>
			{children}
		</Tippy>
	);
};

InteractiveTooltip.propTypes = {
	children: PropTypes.node.isRequired,
	tooltip: PropTypes.string.isRequired,
	onCTAClick: PropTypes.func.isRequired,
	position: PropTypes.string.isRequired
};

const WithOptionalTooltip = ( { children, tooltip, onCTAClick, tooltipPosition } ) => {
	if ( tooltip && onCTAClick ) {
		return (
			<InteractiveTooltip tooltip={tooltip} onCTAClick={onCTAClick} position={tooltipPosition}>
				{children}
			</InteractiveTooltip>
		);
	}

	const tooltipContent = tooltip ? (
		<div style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
			{tooltip}
		</div>
	) : null;

	return tooltip ? (
		<Tooltip label={tooltipContent} position="right" withArrow withinPortal>
			<div>
				{children}
			</div>
		</Tooltip>
	) : children;
};

WithOptionalTooltip.propTypes = {
	children: PropTypes.node.isRequired,
	tooltip: PropTypes.string,
	onCTAClick: PropTypes.func,
	tooltipPosition: PropTypes.string
};

WithOptionalTooltip.defaultProps = {
	tooltip: undefined,
	onCTAClick: undefined,
	tooltipPosition: 'right'
};

export default WithOptionalTooltip;
